(function(){
  'use strict';
  if(window.__SG_ART_SELLER_RESULT_READY__) return;
  window.__SG_ART_SELLER_RESULT_READY__ = true;

  function injectStyles(){
    if(document.getElementById('sg-art-seller-result-styles')) return;
    var style = document.createElement('style');
    style.id = 'sg-art-seller-result-styles';
    style.textContent =
      '.sg-art-checker__seller-result{display:flex;align-items:center;justify-content:space-between;gap:22px;margin-top:16px;padding:18px 20px;border:1px solid #d7dfda;border-left:4px solid #226f54;border-radius:5px;background:#f6f8f7}' +
      '.sg-art-checker__seller-result[hidden]{display:none!important}.sg-art-checker__seller-result-copy{min-width:0}' +
      '.sg-art-checker__seller-result-kicker{margin:0 0 3px!important;color:#226f54!important;font-size:9.5px!important;font-weight:800!important;letter-spacing:.06em!important;line-height:1.35!important;text-transform:uppercase!important}' +
      '.sg-art-checker__seller-result strong{display:block;margin:0;color:#171717;font-size:13px;line-height:1.4}' +
      '.sg-art-checker__seller-result-copy>p:last-child{margin:5px 0 0!important;color:#616161!important;font-size:10.5px!important;line-height:1.55!important}' +
      '.sg-art-checker__seller-result a{display:inline-flex;flex:0 0 auto;min-width:138px;min-height:42px;padding:9px 14px;align-items:center;justify-content:center;border:1px solid #226f54;border-radius:5px;background:#226f54;color:#fff!important;-webkit-text-fill-color:#fff!important;font-size:10.5px;font-weight:800;line-height:1.2;text-decoration:none!important;text-transform:uppercase}' +
      '.sg-art-checker__seller-result a:hover,.sg-art-checker__seller-result a:focus-visible{border-color:#111;background:#111;color:#fff!important;-webkit-text-fill-color:#fff!important}' +
      '.sg-art-checker__seller-result a:focus-visible{outline:2px solid #226f54;outline-offset:2px}' +
      '@media(max-width:749px){.sg-art-checker__seller-result{align-items:stretch;flex-direction:column;gap:13px;padding:16px}.sg-art-checker__seller-result a{width:100%;min-height:46px}}';
    document.head.appendChild(style);
  }

  function init(root){
    var results = root.querySelector('[data-sg-art-results]');
    var brand = root.querySelector('[data-sg-art-brand]');
    var code = root.querySelector('[data-sg-art-code]');
    if(!results || !brand || !code) return;

    var box = document.createElement('div');
    box.className = 'sg-art-checker__seller-result';
    box.hidden = true;
    box.setAttribute('data-sg-art-seller-result', '');
    box.innerHTML =
      '<div class="sg-art-checker__seller-result-copy">' +
        '<p class="sg-art-checker__seller-result-kicker">Thinking of selling it?</p>' +
        '<strong>Get an offer from Street Garms</strong>' +
        '<p>We buy used Stone Island directly. Cash or store credit, free tracked UK postage and no seller fees.</p>' +
      '</div>' +
      '<a href="/pages/sell-stone-island?source=art_checker" data-sg-seller-cta data-sg-seller-source="art_checker">Get an offer</a>';
    results.appendChild(box);

    var link = box.querySelector('a');

    function update(){
      var brandText = String(brand.textContent || '').trim();
      var codeText = String(code.textContent || '').trim();
      var isStoneIsland = brandText.indexOf('Stone Island') > -1;
      var hasResult = !results.hidden && codeText && codeText !== '—';

      if(!hasResult || !isStoneIsland){
        box.hidden = true;
        return;
      }

      var href = '/pages/sell-stone-island?source=art_checker';
      if(codeText) href += '&art=' + encodeURIComponent(codeText);
      link.setAttribute('href', href);
      box.hidden = false;
    }

    var observer = new MutationObserver(update);
    observer.observe(results, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['hidden']
    });

    update();
  }

  function boot(){
    injectStyles();
    document.querySelectorAll('[data-sg-art-checker]').forEach(init);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
